import type { FaireProductEntity } from "../../entity_types/product";

export const astoria_granola_1: FaireProductEntity = {
  token: "astoria-granola-1",
  type: "product",
  name: "Artisan Granola Mix",
  brandName: "Astoria Granola Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f5fc70299bc5e6af6328c56ce5a6715af841aaa37d9002be999bf81d53d7624.webp",
  priceDollars: 13,
  msrpDollars: 22,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
